import { WPClient } from "../../wp/client/WPClient";
import { LogosGridModuleType } from "./LogosGrid";

/* jscpd:ignore-start */
interface FetchLogosProps {
  locale: string | undefined;
  defaultLocale: string | undefined;
  offset: number;
  module: LogosGridModuleType;
  postsPerPage: number;
  page: number;
}
/* jscpd:ignore-end */

export type LogosCardElementType = Awaited<
  ReturnType<typeof fetchLogos>
>["posts"][0];

export const fetchLogos = async ({
  locale,
  defaultLocale,
  postsPerPage,
  module,
  offset,
  page,
}: FetchLogosProps) => {
  const client = new WPClient({ locale, defaultLocale });

  const { type, logos: selectedPosts } = module.logos_grid;

  const postsResult = await client.getPosts({
    type: "logos",
    page: page,
    perPage: postsPerPage,
    offset,
    fields: ["id", "date", "acf.header_logos"],
    ...(type === "logos" && {
      includeIds: { ids: selectedPosts || [], keepOrder: true },
    }),
  });

  const posts = postsResult.posts.map((post) => {
    const header = post.acf?.header_logos;
    return header;
  });

  return {
    posts,
    totalPosts: postsResult.totalPosts,
  };
};
